import React from "react";
import styles from "./about.module.scss";

export const EventAbout = ({ goToBookNow, goToviewLocation, ...props }) => {
  return (
    <section>
      <div className="container">
        <div className={styles.about_container}>
          <div className="">
            <div className={styles.image_wrapper}>
              <img
                src="https://images.unsplash.com/photo-1661961111247-e218f67d1cd2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
                alt="UniSearch Conference"
              />
              <div className={styles.left_img_border_left}></div>
              <div className={styles.left_img_border_bottom}></div>
            </div>
          </div>
          <div className="">
            <h1 className={styles.about_heading}>
              About the <br /> UniSearch Conference
            </h1>
            <div className={styles.des_wrapper}>
              <p>
                UniSearch is produced by the team behind Metl Summit and Fiver
                Collision two of the largest and fastest growing education
                conferences. UniSearch is produced by the team behind Metl
                Summit and Fiver Collision two of the largest and fastest
                growing education conferences. UniSearch is produced by the team
                behind Metl Summit and Fiver Collision two of the largest and
                fastest growing education conferences. UniSearch is produced by
                the team behind Metl Summit and Fiver Collision two of the
                largest and fastest growing education conferences. UniSearch is
                produced by the team behind Metl Summit and Fiver Collision two
                of the largest and fastest growing education conferences.
              </p>

              <div className={styles.left_border}></div>
            </div>
            <div className={styles.button_container}>
              <button
                onClick={goToBookNow}
                className="btn btn-secondary btn-md"
              >
                Book Now
              </button>
              <button
                onClick={goToviewLocation}
                className="btn btn-outline-grey btn-md"
              >
                View Location
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventAbout;
